import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { GeneratorService } from "@/services/generator-service";
import type {
  GenerateRandomCodeRequestDto,
  GenerateRandomCodeResponseDto
} from "@/types";

type UseGenerateRandomCodeQueryProps = {
  queryParams: GenerateRandomCodeRequestDto;
  options?: Omit<UseQueryOptions<GenerateRandomCodeResponseDto>, "queryKey">;
};

export const useGenerateRandomCodeQuery = ({
  queryParams,
  options
}: UseGenerateRandomCodeQueryProps) => {
  return useQuery({
    queryKey: ["generate-random-code", queryParams],
    queryFn: async () => {
      return await GeneratorService.generateRandomCode({
        payload: queryParams
      });
    },
    ...options
  });
};
